import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/toaster";

// Layout Components
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

// Main Pages
import HomePage from "@/pages/HomePage";
import ComparePage from "@/pages/ComparePage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";

// Service Pages
import ServicesPage from "@/pages/ServicesPage";
import TermLifePage from "@/pages/TermLifePage";
import WholeLifePage from "@/pages/WholeLifePage";
import UniversalLifePage from "@/pages/UniversalLifePage";
import PremiumFinancingPage from "@/pages/PremiumFinancingPage";
import EstatePlanningPage from "@/pages/EstatePlanningPage";
import CarriersPage from "@/pages/CarriersPage";

// Advisor Pages
import ForAdvisorsPage from "@/pages/ForAdvisorsPage";
import BusinessModelPage from "@/pages/BusinessModelPage";
import TrainingLicensingPage from "@/pages/TrainingLicensingPage";
import CompensationModelPage from "@/pages/CompensationModelPage";
import IncomeOpportunityPage from "@/pages/IncomeOpportunityPage";
import SuccessStoriesPage from "@/pages/SuccessStoriesPage";
import LeadershipModelPage from "@/pages/LeadershipModelPage";
import TechnologyPlatformPage from "@/pages/TechnologyPlatformPage";
import BecomeAnAgentPage from "@/pages/BecomeAnAgentPage";

// Content Pages
import EducationPage from "@/pages/EducationPage";
import BlogPage, { BlogPostPage } from "@/pages/BlogPage";

function App() {
  return (
    <LanguageProvider>
      <div className="App bg-[#020617] min-h-screen">
        <BrowserRouter>
          <Navbar />
          <main>
            <Routes>
              {/* Main Pages */}
              <Route path="/" element={<HomePage />} />
              <Route path="/compare" element={<ComparePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />

              {/* Service Pages */}
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/services/term-life" element={<TermLifePage />} />
              <Route path="/services/whole-life" element={<WholeLifePage />} />
              <Route path="/services/universal-life" element={<UniversalLifePage />} />
              <Route path="/premium-financing" element={<PremiumFinancingPage />} />
              <Route path="/services/estate-planning" element={<EstatePlanningPage />} />
              <Route path="/carriers" element={<CarriersPage />} />

              {/* Advisor Pages */}
              <Route path="/for-advisors" element={<ForAdvisorsPage />} />
              <Route path="/business-model" element={<BusinessModelPage />} />
              <Route path="/training-licensing" element={<TrainingLicensingPage />} />
              <Route path="/compensation-model" element={<CompensationModelPage />} />
              <Route path="/income-opportunity" element={<IncomeOpportunityPage />} />
              <Route path="/success-stories" element={<SuccessStoriesPage />} />
              <Route path="/leadership-model" element={<LeadershipModelPage />} />
              <Route path="/technology-platform" element={<TechnologyPlatformPage />} />
              <Route path="/become-an-agent" element={<BecomeAnAgentPage />} />

              {/* Content Pages */}
              <Route path="/education" element={<EducationPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
            </Routes>
          </main>
          <Footer />
          {/* AI Chat Widget loaded via index.html */}
        </BrowserRouter>
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
